export default __webpack_public_path__ + "static/media/decada-0070-0008-min.def0564d.jpg";